import * as React from 'react';
import type { IsinIconPropsType } from './types';

const IsinIcon: React.FC<IsinIconPropsType> = ( props: IsinIconPropsType ) => {
    const imgPath = `/static/front/assets/table/hellip${ props.trancheCount === 2
        ? 2 : ( props.trancheCount === 3 ? '' : ( props.trancheCount > 3 ? 5 : null ) ) }.png`;

    return (
        <img onClick={ props.onClick } src={ imgPath } className={ props.className }/>
    );
};

export { IsinIcon };
